<div *ngIf="existingReservation" class="animate-fade-in-down">
  <div class="flex flex-col justify-center items-center mb-4">
    <ng-content></ng-content>
  </div>
  <app-card-shadow>

    <div class="flex justify-around gap-2">
      <button *ngIf="editReservation && !frontMode && !editView" (click)="reset()" appNextOutlined>
        <app-loader *ngIf="loadingReset" size="small"></app-loader>
        <svg *ngIf="!loadingReset" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" />
          <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" />
        </svg>
      </button>
      <div *ngIf="!editReservation || (editReservation && frontMode)"
        [ngClass]="admin ? 'flex items-center gap-5 justify-center w-full' :'w-full flex'">
        <span
          class="border border-lightGray rounded-full w-full py-1 px-10 text-xl text-darkGray">{{existingReservation.registration_number}}</span>
        <span class="border border-lightGray rounded-full w-full py-1 px-10 text-darkGray text-sm font-bold"
          *ngIf="!editReservation && admin">{{existingReservation.phone}}</span>
      </div>
      <input *ngIf="!frontMode && editReservation" [(ngModel)]="registration" [disabled]="!!existingReservation.paid || paidTried"
        class="border border-lightGray rounded-full w-full py-1 text-center text-xl text-darkGray">
    </div>
    <div *ngIf="!editReservation" class="border-b border-lightGray pb-3 w-full flex flex-col gap-1 mt-3">
      <p class="text-red2 text-sm">Ya tienes una cita en <span
          class="font-bold">{{existingReservation.station.name}}</span> el <span
          class="font-bold">{{existingReservation.date|date:'dd/MM/yyyy'}}</span> a las <span
          class="font-bold">{{existingReservation.hour.hour}}</span></p>
      <p class="text-red2 text-sm">En <span class="font-bold">{{existingReservation.service.name}} /
          {{existingReservation.vehicle.name}}</span></p>
      <p>Codigo de la cita: {{existingReservation.station.code}}{{existingReservation.id}}</p>
    </div>
    <!--<div *ngIf="!editReservation && admin" class="border-b border-lightGray">
      <div  class=" p-2 mb-2 rounded-md w-full flex flex-col gap-1 mt-2">
        <p class="text-lg text-darkGray font-bold"> {{existingReservation.phone}}</p>
      </div>
    </div>-->
    <div *ngIf="!editReservation && updatedSuccessTrue" class="border-b border-lightGray">
      <div class=" p-2 mb-2 rounded-md w-full flex flex-col gap-1 mt-2">
        <p class="text-sm text-green font-bold">{{ updatedSuccessTrue }}</p>
      </div>
    </div>
    <div class="mt-2 w-full text-center" *ngIf="!editReservation && !confirmed && !admin">
      <p class="text-darkGray text-sm">Confirma el número de teléfono para gestionar la cita</p>
      <input [(ngModel)]="phoneConfirm" appOutlineInput placeholder="Número de telefono" class="mt-2 text-center"
        type="text">
      <div class="flex w-full justify-center mt-3">
        <button (click)="checkPhoneNumber()" appNextButton>Confirmar</button>
      </div>
    </div>
    <div *ngIf="!editReservation && (confirmed || admin)" class="mt-2 w-full">
      <div class="grid grid-cols-2 w-full gap-4">
        <button appOutlineButton class="cursor-pointer hidden md:block" (click)="descargarArchivo()"> Descargar
          justificante</button>
        <button appOutlineButton class="cursor-pointer md:hidden" (click)="descargarArchivo()">Justificante</button>
        <button *ngIf="!messageSended || messageError" (click)="sendMessage()" class="hidden md:block"
          appOutlineButton>Enviar datos por sms <app-loader size="extra-small" *ngIf="loadingSms"></app-loader></button>
        <button *ngIf="!messageSended || messageError" (click)="sendMessage()" class="md:hidden" appOutlineButton>Enviar
          sms <app-loader size="extra-small" *ngIf="loadingSms"></app-loader></button>
        <button *ngIf="messageSended && !messageError" (click)="sendMessage()" class="hidden md:block"
          appOutlineGreenButton>Reenviar datos por sms <app-loader size="extra-small"
            *ngIf="loadingSms"></app-loader></button>
        <button *ngIf="messageSended && !messageError" (click)="sendMessage()" class="md:hidden"
          appOutlineGreenButton>Reenviar sms <app-loader size="extra-small" *ngIf="loadingSms"></app-loader></button>
        <div></div>
        <div class="flex justify-center">
          <span *ngIf="messageSended && !messageError" class="text-xs text-green">Mensaje enviado correctamente</span>
          <span *ngIf="messageSended && messageError" class="text-xs text-red2">Error al enviar el mensaje</span>
        </div>
        <!-- TODO: Hacer formualrio -->
        <input [(ngModel)]="email" appOutlineInput placeholder="Email" class="col-span-2" type="text">
        <button (click)="sendProofToEmail()" appOutlineButton class="col-span-2 flex justify-center items-center gap-4"
          [disabled]="loadingEmail">
          Enviar justificante por mail <app-loader size="extra-small" *ngIf="loadingEmail"></app-loader>
        </button>
      </div>
      <div class="mt-3 flex justify-center w-full gap-4"  *ngIf="!association">
        <button (click)="goToEdit()"
          class="flex flex-row justify-center items-center bg-yellow hover:bg-white border border-white hover:border-yellow cursor-pointer gap-x-2 px-6 py-4 rounded-full duration-200 text-darkGray">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="1.00" stroke-linecap="round" stroke-linejoin="round" class="text-gray-700 w-5">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
            <path d="M16 3v4" />
            <path d="M8 3v4" />
            <path d="M4 11h16" />
            <path d="M7 14h.013" />
            <path d="M10.01 14h.005" />
            <path d="M13.01 14h.005" />
            <path d="M16.015 14h.005" />
            <path d="M13.015 17h.005" />
            <path d="M7.01 17h.005" />
            <path d="M10.01 17h.005" />
          </svg>
          <p class="hidden md:block">Gestionar cita</p>
          <p class="md:hidden text-sm">Gestionar</p>
        </button>
        <button [disabled]="loadingCancel" (click)="cancelReservation()" *ngIf="!this.updatedSuccessTrue && !this.existingReservation.paid && !this.paidTried"
          class="flex justify-center gap-4 text-center items-center cursor-pointer text-sm rounded-full px-6 py-4 border hover:border-red2 hover:bg-transparent hover:text-red2 bg-red2 text-white duration-200">
          <span class="hidden md:block">ANULAR CITA</span> <span class="md:hidden text-sm">ANULAR</span> <app-loader
            size="extra-small" *ngIf="loadingCancel"></app-loader>
        </button>
      </div>
      <!-- <div class="mt-6" *ngIf="!updatedSuccessTrue && (existingReservation.paid || paidTried)">
        <p class="">Para gestionar o anular su cita ya pagada,</p>
        <p>contacte con el teléfono 871 57 55 44</p>
      </div> -->
    </div>
    <app-loader *ngIf="editReservation && loading" size="small"></app-loader>
    <div *ngIf="editReservation && !loading" class="flex flex-col mt-4 justify-start px-0 md:px-4 animate-fade-in">
      <p class="text-xs text-lightGray text-start my-2">Para cambiar otros datos de tu reserva, pincha en volver, anula
        y reserva de nuevo</p>
      <!--<div class="grid grid-cols-3 gap-x-8 gap-y-2">
        <div class="animate-fade-in text-start {{frontMode ? 'border-b border-primary' : ''}}">
          <p class="text-primary text-sm">Tipo de inspección</p>
        </div>
        <div class="animate-fade-in text-start {{frontMode ? 'border-b border-primary' : ''}}">
          <p class="text-primary text-sm" >Tipo de vehículo </p>
        </div>
        <div class="animate-fade-in text-start {{frontMode ? 'border-b border-primary' : ''}}">
          <p class="text-primary text-sm">Tipo de combustible</p>
        </div>
        <div *ngIf="frontMode" class="animate-fade-in text-start">
          <p class="text-darkGray text-sm">{{existingReservation.service.name}}</p>
        </div>
        <div *ngIf="!frontMode" class="flex flex-col gap-y-2 animate-fade-in">
          <select appFormSelectSquare [(ngModel)]="selectedService" (change)="loadVehicles()">
            <option disabled [ngValue]="undefined">Selecciona un tipo de inspección</option>
            <option *ngFor="let service of services" [ngValue]="service">{{service.name}}</option>
          </select>
        </div>
        <div *ngIf="frontMode" class="animate-fade-in text-start">
          <p class="text-darkGray text-sm">{{existingReservation.vehicle.name}}</p>
        </div>
        <div *ngIf="!frontMode" class="flex flex-col gap-y-2 animate-fade-in">
          <select appFormSelectSquare [(ngModel)]="selectedVehicle" (change)="loadFuels()">
            <option disabled [ngValue]="undefined">Selecciona un vehículo</option>
            <option *ngFor="let vehicle of vehicles" [ngValue]="vehicle">{{vehicle.name}}</option>
          </select>
        </div>
        <div *ngIf="frontMode" class="animate-fade-in text-start">
          <p class="text-darkGray text-sm">{{existingReservation.fuel.name}}</p>
        </div>
        <div *ngIf="!frontMode" class="flex flex-col gap-y-2 animate-fade-in">
          <select appFormSelectSquare [(ngModel)]="selectedFuel" (change)="loadStates()">
            <option disabled [ngValue]="undefined">Selecciona un combustible</option>
            <option *ngFor="let fuel of fuels" [ngValue]="fuel">{{fuel.name}}</option>
          </select>
        </div>
      </div>-->
      <div class="grid grid-cols-1 md:grid-cols-2 my-4 gap-x-8" *ngIf="!frontMode">
        <div class="flex flex-col text-start">
          <p *ngIf="name == null || name !== ''" class="text-primary text-sm ml-1 mb-1 animate-fade-in-up">Nombre
            (opcional)</p>
          <input [(ngModel)]="name" type="text" placeholder="Nombre (opcional)" [disabled]="!!existingReservation.paid || paidTried"
            class="w-full rounded-full bg-lightGray2 px-3 py-2 outline-0 border-0 {{name == null || name === '' ? 'mt-6' : ''}}" />
        </div>
        <div class="flex flex-col text-start">
          <p *ngIf="email == null || email !== ''" class="text-primary text-sm ml-1 mb-1 animate-fade-in-up">Email
            (opcional)</p>
          <input [(ngModel)]="email" type="email" placeholder="Email (opcional)" [disabled]="!!existingReservation.paid || paidTried"
                  class="w-full rounded-full bg-lightGray2 px-3 py-2 outline-0 border-0 {{email == null || email === '' ? 'mt-6' : ''}}
                  {{(email && validateEmail(email)) || email === '' || email === null ? 'mb-4' : ''}}" />
          <div *ngIf="email && !validateEmail(email)" class="text-xs text-red2 ml-1" appFormError>Email no válido</div>
        </div>
        <div class="flex flex-col text-start">
          <p *ngIf="phone_number == null || phone_number !== ''"
            class="text-primary text-sm ml-1 mb-1 animate-fade-in-up">Móvil *</p>
          <input [(ngModel)]="phone_number" placeholder="Móvil *" type="text" [disabled]="!!existingReservation.paid || paidTried"
                  class="w-full rounded-full bg-lightGray2 px-3 py-2 outline-0 border-0 {{phone_number == null || phone_number === '' ? 'mt-6' : ''}}
                 {{(phone_number && validateEmail(phone_number)) ? 'mb-10' : ''}}" />
          <div *ngIf="phone_number && !validatePhoneNumber(phone_number) || phone_number === ''"
            class="text-xs text-red2 ml-1" appFormError>Número
            de teléfono no válido
          </div>
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 my-4 gap-y-2 gap-x-8" *ngIf="!isProfessional">
        <div>
          <div class="animate-fade-in text-start pr-4 w-fit {{frontMode ? 'border-b border-primary' : ''}}">
            <p class="text-primary text-sm">Comunidad</p>
          </div>
          <div *ngIf="!frontMode" class="flex flex-col gap-y-2 animate-fade-in">
            <select appFormSelectSquare [(ngModel)]="selectedState" (change)="loadStations()" [disabled]="!!existingReservation.paid || paidTried">
              <option disabled [ngValue]="undefined">Selecciona una comunidad</option>
              <option *ngFor="let state of states" [ngValue]="state">{{state.name}}</option>
            </select>
          </div>
          <div *ngIf="frontMode" class="animate-fade-in text-start">
            <p class="text-darkGray text-sm">{{existingReservation.station.state.name}}</p>
          </div>
        </div>

        <div>
          <div class="animate-fade-in text-start">
            <p class="text-primary text-sm">Centro</p>
          </div>

          <div class="flex flex-col gap-y-2 animate-fade-in">
            <select appFormSelectSquare [(ngModel)]="selectedStation" (change)="loadDates()">
              <option disabled [ngValue]="undefined">Selecciona una estación</option>
              <option *ngFor="let station of stations" 
                  [ngValue]="station"
                  [disabled]="(!!existingReservation.paid || paidTried) && station.code == '0999'"
                >{{station.name}}</option>
            </select>
          </div>
        </div>



      </div>
      <div class="grid grid-cols-1 md:grid-cols-4 gap-x-6 animate-fade-in">
        <div class="md:col-span-3 flex text-start flex-col" *ngIf="!isProfessional">
          <h1 class="text-sm text-primary mb-2">Fecha</h1>
          <app-month-calendar [loading]="loadingDates" (nextMonth)="nextMonth()" (prevMonth)="prevMonth()"
            [changeMonth]="true" [frontMode]="true" [blockedDates]="blockedDates" [month]="month" [year]="year"
            [selectDaysMode]="true" selectedColor="#168FFB" [currentSelection]="[selectedDate ?? '']"
            (onSelectDayChange)="onSelectedDay($event)"></app-month-calendar>
        </div>
        <div class="flex flex-col text-center md:text-start animate-fade-in mt-4 md:mt-0">
          <label *ngIf="!isProfessional" class="text-sm mb-2 pl-[4px] text-primary">Hora <span *ngIf="!selectHour"
              class="text-darkGray text-sm ml-10">{{existingReservation.hour.hour}}h</span></label>
          <select *ngIf="!loadingHours && selectHour && !isProfessional" [(ngModel)]="selectedHour" appFormSelectSquare>
            <option disabled [ngValue]="undefined">Selecciona una hora</option>
            <option class="{{hour.available<1 ? 'bg-lightGray2' : ''}}" [ngValue]="hour" [disabled]="hour.available<1"
              *ngFor="let hour of hours">{{hour.hour}} {{hour.available>0 ? ' - '+hour.available : ''}}</option>
          </select>
          <button *ngIf="!selectHour && !isProfessional" class="mt-2 hover:shadow-lg duration-300"
            (click)="selectHour=true" appNextOutlined>Cambiar hora</button>
          <button class="mt-8 mb-2 hover:shadow-lg" appNextButton (click)="update()"> Cambiar</button>
          <button *ngIf="!editView" (click)="toggleEditReservation()"
            class="bg-red-500 text-white shadow-sm p-2 px-4 rounded-2xl hover:shadow-lg duration-300">Volver</button>
          <button *ngIf="editView" (click)="closeEditModal()" type="button"
            class="bg-red-500 text-white shadow-sm p-2 px-4 rounded-2xl hover:shadow-lg duration-300">
            Cancelar edición
          </button>
        </div>
      </div>

      <div class="mt-4 border-2 rounded-2xl border-lightGray2 flex justify-between items-center"
        *ngIf="!isProfessional && (!editReservationLogs || (editReservationLogs && editReservationLogs.length == 0))">
        <span class="px-4 py-1">Sin histórico de modificaciones</span>
      </div>
      <div class="mt-4 border-2 rounded-2xl border-lightGray2 cursor-pointer"
        *ngIf="!isProfessional && editReservationLogs && editReservationLogs.length > 0" (click)="toggleDropdown()">
        <div class="flex justify-between items-between cursor-pointer w-full">
          <span class="px-4 py-1">Histórico de modificaciones</span>
          <span class="px-3 py-1">
            <svg width="24px" height="24px" viewBox="2 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" [ngClass]="{
              'transition-transform duration-300 ease-in-out': true,
              'rotate-180': dropdownEditReservationLogs
            }">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L6.29289 9.70711C5.90237 9.31658 5.90237 8.68342 6.29289 8.29289C6.68342 7.90237 7.31658 7.90237 7.70711 8.29289L12 12.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L12.7071 14.7071Z"
                fill="#A5A5A5" />
            </svg>
          </span>
        </div>
        <div class="mt-4 space-y-4" 
          *ngIf="dropdownEditReservationLogs">
          <div *ngFor="let item of editReservationLogs">
            <p>Fecha de modificación: {{ item.created_at | date: 'dd/MM/yyyy HH:mm'}}</p>
            <ul class="text-center grid grid-cols-2 lg:grid-cols-4 border-2 border-lightGray2 rounded-2xl mx-4 mb-4 py-2">
              <li class="mt-4">
                <div>
                  <span class="font-semibold">Matrícula</span>
                </div>
                <div>
                  {{item.registration_number}}
                </div>
              </li>
              <li class="mt-4">
                <div>
                  <span class="font-semibold">Centro</span>
                </div>
                <div>
                  {{item.station.name}}
                </div>
              </li>
              <li class="mt-4">
                <div>
                  <span class="font-semibold">Fecha</span>
                </div>
                <div>
                  {{item.date}}
                </div>
              </li>
              <li class="mt-4">
                <div>
                  <span class="font-semibold">Hora</span>
                </div>
                <div>
                  {{item.hour.hour}}
                </div>
              </li>
              <li class="mt-4">
                <div>
                  <span class="font-semibold">Móvil</span>
                </div>
                <div>
                  {{item.phone}}
                </div>
              </li>
              <li class="mt-4">
                <div>
                  <span class="font-semibold">Nombre</span>
                </div>
                <div>
                  {{item.name}}
                </div>
              </li>
              <li class="col-span-2 mt-4">
                <div>
                  <span class="font-semibold">Email</span>
                </div>
                <div>
                  {{item.email}}
                </div>
              </li>
            </ul>
          </div>
        </div>



      </div>
    </div>

    <div class="mx-auto max-w-[34rem] mt-8" *ngIf="existingReservation.station.state.name === 'Islas Baleares' && existingReservation.station.name !== 'ITV Móvil Ibiza (Recinto Ferial)' && existingReservation.payment_method.slug !== 'pago-estacion-tarjeta-ibiza' && !existingReservation.paid && !editReservation && (confirmed || admin) && !paidTried && !association">
      <app-payment-card [existingReservation]="existingReservation"></app-payment-card>
    </div>

  </app-card-shadow>
  <div *ngIf="!editReservation" class="mx-auto py-6 w-full flex items-center justify-center">
    <div (click)="onReturnClick.emit()" appFrontBack>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25"
        stroke-linecap="round" stroke-linejoin="round" class="w-5">
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M5 12l14 0" />
        <path d="M5 12l4 4" />
        <path d="M5 12l4 -4" />
      </svg>
      <p>Volver</p>
    </div>
  </div>
</div>

<p-confirmDialog #cancel>
  <ng-template pTemplate="headless" let-message>
    <div class="flex flex-col items-center p-5 surface-overlay border-round bg-white rounded-2xl">
      <div class="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem">
        <i class="pi pi-question text-5xl"></i>
      </div>
      <span class="font-bold text-2xl block mb-2 mt-4">
                {{ message.header }}
            </span>
      <p class="mb-0">{{ message.message }}</p>
      <div class="flex items-center gap-2 mt-4">
        <button
          (click)="cancel.accept()"
          class="bg-primary text-white p-2 bg-opacity-95 rounded-md hover:bg-opacity-90">
          Sí
        </button>
        <button
          pButton
          label="No"
          (click)="cancel.reject()"
          class="bg-primary bg-opacity-0 p-2 hover:bg-opacity-10 text-primary border border-primary">
        </button>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>

<div class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50" *ngIf="showModal">
  <div class="bg-white rounded-lg p-4 w-1/2 mx-auto">
    <p class="text-center text-lg font-bold ">Su reserva ha sido cancelada correctamente</p>
    <button (click)="showModal = false" class="bg-primary text-white p-2 bg-opacity-95 rounded-md hover:bg-opacity-90">Cerrar</button>
  </div>
</div>